export default {
  '&DonationAskForm.CurrencySymbol': '$',
  '&DonationAskForm.AmountGroupLabel': 'Donation amount',
  '&DonationAskForm.OtherAmountLabel': 'Other amount',
  '&DonationAskForm.OtherOption': 'Other',
  '&DonationAskForm.MonthlyGiftText':
    'Repeat this gift monthly so that I can help animals all year long.',
  '&DonationAskForm.MonthlySuffix': '/mo',
  '&DonationAskForm.MoreGivingOptions': 'More Giving Options',
  '&DonationAskForm.SkipThis': 'Skip This »',
} as TextDictionary;
